/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Frame_TitleInputs */

const en_pc_online_frame_title = /** @type {(inputs: Pc_Online_Frame_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft PDF workbench`)
};

const zh_pc_online_frame_title = /** @type {(inputs: Pc_Online_Frame_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft PDF 工作台`)
};

/**
* | output |
* | --- |
* | "PdfCraft PDF workbench" |
*
* @param {Pc_Online_Frame_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_frame_title = /** @type {((inputs?: Pc_Online_Frame_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Frame_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_frame_title(inputs)
	return zh_pc_online_frame_title(inputs)
});
export { pc_online_frame_title as "pc.online.frame_title" }